import React from 'react'

type SearchIconProps = {
  className?: string
}

const SearchIcon: React.FC<SearchIconProps> = ({ className }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.875 0C10.672 0 13.75 3.07804 13.75 6.875C13.75 8.54843 13.1514 10.0816 12.1576 11.2738L15.7544 14.8706L14.8706 15.7544L11.2738 12.1576C10.0816 13.1514 8.54843 13.75 6.875 13.75C3.07804 13.75 0 10.672 0 6.875C0 3.07804 3.07804 0 6.875 0ZM6.875 1.25C3.7684 1.25 1.25 3.7684 1.25 6.875C1.25 9.9816 3.7684 12.5 6.875 12.5C9.9816 12.5 12.5 9.9816 12.5 6.875C12.5 3.7684 9.9816 1.25 6.875 1.25Z"
      fill="#848484"
    />
  </svg>
)

export default SearchIcon
